// Webpack Imports
import * as bootstrap from "bootstrap";

var lozad = require("lozad");

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
